<app-view *ngIf="banner" [banner]="banner" (bannerCreated)="updateBanner($event)" [buttonLabel]="'Submit Updates'">

</app-view>